import type { ReactNode } from 'react';
import { desktop } from '../lib/desktop';

/** A link to another website. In the desktop app it opens in the person's own browser. */
export function ExternalLink({
  href,
  children,
  className,
}: {
  href: string;
  children: ReactNode;
  className?: string;
}) {
  // Only web addresses: a saved link can never run code or open a file.
  const safe = /^https?:\/\//i.test(href) ? href : '#';
  return (
    <a
      href={safe}
      target="_blank"
      rel="noopener noreferrer"
      {...(className ? { className } : {})}
      onClick={(e) => {
        const d = desktop();
        if (d && safe !== '#') {
          e.preventDefault();
          void d.openExternal(safe);
        }
      }}
    >
      {children}
    </a>
  );
}
